import React from "react";
import AccordionV2 from "@components/Accordion/AccordionV2";
import EventsAwardsAccordionHeader from "@events-awards/EventsAwardsAccordionHeader";
import { CITYGATE_URL } from "@util/constant";

/**
 * Component to render Citigate Dewe Rogerson Singapore Pte Ltd section on Partners page
 */
const CitigateSection = (): React.ReactElement => {
  return (
    <div
      className="rounded-bl-lg rounded-br-lg bg-gray-150"
      data-testid="citigate-section-component"
    >
      <AccordionV2
        testId="citigate"
        className="rounded-bl-lg rounded-br-lg border-l border-r py-4"
        headerChildren={
          <EventsAwardsAccordionHeader title="Citigate Dewe Rogerson Singapore Pte Ltd" />
        }
        arrowClassName="h-auto w-auto -rotate-90 mr-6 border-none"
        isArrowRight
      >
        <div className="mt-4 border-t border-gray-175 px-6 py-4 pt-4">
          <p className="mb-12">
            Citigate Dewe Rogerson is part of a leading international
            consultancy specialising in financial and corporate communications.
            Headquartered in London, our mission is to ensure that our clients
            engage to best possible effect with all relevant stakeholders across
            capital markets, government, business and consumers. We are trusted
            advisors to major and emerging companies and multinational
            corporations – whenever clear and persuasive communication will make
            a difference.
          </p>

          <p className="mb-12">
            With over 30 years&apos; experience operating in Asia, including in
            Singapore, we operate as one team across our six markets of
            Singapore, Hong Kong, Beijing, Shanghai, Tokyo and Taipei. Our
            business spans all major industrial sectors, providing media
            relations, investor relations, crisis communications, public policy
            and litigation support. We are acknowledged as a leader in IPOs and
            M&A advisory, with a long track record spanning the full spectrum of
            financial, corporate and investor communications.
          </p>

          <p>
            Citigate Dewe Rogerson Singapore is the market leader in capital
            market transactions and investor relations, having supported over
            300 IPOs on the Singapore Exchange over the past 30 years.
          </p>

          <p>
            For more information, visit&nbsp;
            <a
              className="text-blue-175 hover:text-gray-750"
              href={CITYGATE_URL}
              target="_blank"
              rel="noreferrer"
            >
              https://citigatedewerogerson.com/asia/about
            </a>
            .
          </p>
        </div>
      </AccordionV2>
    </div>
  );
};

export default CitigateSection;
